// Dependencies
import React from "react";
import styled from "styled-components/macro";
import { ArrowRightAlt } from "@material-ui/icons";
// import MetaTags from "react-meta-tags";
//import { Helmet } from "react-helmet";

// Images
import HeroImg from "../assets/images/hero.jpg";
import AboutImg from "../assets/images/om-oss.jpg";
import CompanyImg from "../assets/images/foretag.jpg";
import QueensImg from "../assets/images/kandidater.jpg";
import ServicesImg from "../assets/images/start4.jpg";
import { LinkToPage } from "../components/LinkToPage";

// STARTPAGE --------------------------------------
export const StartPage = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist</title>
        <meta
          name="description"
          content="We Exist är ett rekryteringsbolag som hjälper ditt företag attrahera, rekrytera och behålla kvinnliga
           medarbetare inom tech och it."
        />
        <meta property="og:title" content="We Exist" />
        <meta
          property="og:description"
          content="We Exist är ett rekryteringsbolag som hjälper ditt företag attrahera, rekrytera och behålla kvinnliga
           medarbetare inom tech och it."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <Hero>
        <HeroImage src={HeroImg} alt="Kvinnor som sitter i en trappa" />
        <HeroTextContainer>
          <HeroHeading>Attract | Recruit | Keep </HeroHeading>
          <HeroText>
            Vi hjälper företag att attrahera, rekrytera samt behålla kvinnliga
            medarbetare inom Tech och IT.
          </HeroText>
        </HeroTextContainer>
      </Hero>
      <Section>
        <Article>
          <Text>
            <Heading>We Exist</Heading>
            <ArticleHeading>Om oss</ArticleHeading>
            På We Exist brinner vi för att förbättra livet för kvinnor och
            förändra arbetssituationen för våra queens. Vi strävar efter
            jämställdhet och vill inspirera, lyfta, samt rekrytera grymma
            kvinnor inom Tech & IT. Efter flera års erfarenhet inom branschen
            har vi många gånger fått höra att “det är omöjligt att anställa
            kvinnor inom Tech & IT för att det inte finns några.” Så nu är vi
            här för att visa: Vi finns visst! We Exist! Vi sitter på ett enormt
            nätverk av kvinnliga it-stjärnor och vi vet exakt vad företag
            behöver göra för att både attrahera och behålla dessa queens.
          </Text>
        </Article>
        <Article>
          <Img src={AboutImg} alt="Människor på ett kontor" />
        </Article>
      </Section>

      <Section2>
        <Article>
          <Text>
            <ArticleHeading>För queens</ArticleHeading>
            <Img src={QueensImg} alt="En grupp kvinnor i en trappa" />
          </Text>
        </Article>
        <Article>
          <TextMargin>
            Våra kvinnor är våra queens och anledningen till att vi grundade We
            Exist är för kvinnornas skull. Vi vet att du finns och vi vill ge
            dig ditt bästa jobb någonsin. Vi vill förbättra arbetslivet där ute
            och garantera att företagen som vi rekryterar dig till aktivt jobbar
            med jämställdhet och är en inkluderande och medveten arbetsplats.
            Vårt mål är inte att vara ytterligare en rekryteringsfirma som ger
            dig ett OK jobb, nej nej. Vi vill göra vårt bästa för att matcha dig
            med en arbetsplats där du kommer trivas, bli respekterad och känna
            dig inkluderad. Vi jobbar med många företag men långt ifrån alla som
            kontaktar oss och de som vi väljer att jobba med granskar vi noga
            innan någon av våra queens blir presenterade för dem. Du är
            fantastisk och därför vill vi bara jobba med företag som kan matcha
            dig.
          </TextMargin>
          <LinkToSite href="https://queens.weexist.se/" target="_blank">
            För queens
            <ArrowRightAlt className="icon-link" />
          </LinkToSite>
        </Article>
      </Section2>

      <Section>
        <Article>
          <Text>
            <ArticleHeading>För företag</ArticleHeading>
            Vi vill hjälpa ert företag att bli mer jämställt och i en
            förlängning även mer lönsamt. En rad samband har hittats mellan
            jämställdhet och lönsamhet i företag och en grund till ett mer
            jämställt arbetsliv handlar om att koppla jämställdhetsfrågan till
            företagets verksamhet och kärnvärden. Samhället, företag och
            organisationer har med andra ord allt att vinna på att bedriva ett
            medvetet och målinriktat jämställdhetsarbete. Vi tackar endast JA
            till att jobba med företag som är villiga att engagera sig till 100%
            och att aktivt jobba med jämställdhetsfrågan på ett långsiktigt
            plan. De företag vi tackar JA till och som väljer att rekrytera via
            oss blir We Exist Approved.
          </Text>
          <LinkToSite href="mailto:hello@weexist.se">
            Kontakta We Exist
            <ArrowRightAlt className="icon-link" />
          </LinkToSite>
        </Article>
        <Article>
          <Img
            src={CompanyImg}
            alt="People sitting around a conference table"
          />
        </Article>
      </Section>

      <Section2>
        <Article>
          <Text>
            <ArticleHeading>Våra tjänster</ArticleHeading>
            <Img src={ServicesImg} alt="People in a conference room" />
          </Text>
        </Article>
        <Article>
          <TextMargin>
            Att endast anställa en kvinnlig medarbetare till sitt team löser
            inte jämställdhetsfrågan på ett företag. Arbetet för en mer
            jämställd arbetsplats behöver utföras på flera olika plan och med
            gemensamma ansträngningar. Vi hjälper därför våra kunder att aktivt
            arbeta med jämställdhet genom att erbjuda en helhetslösning från ax
            till limpa. Vi hjälper bl.a till att göra en inventering av ert
            företag genom titta på konkreta siffror och mäta data, vi går igenom
            mål och ambitioner, skriver en jämställdhetspolicy, rekryterar
            kvinnor till ert företag, har workshops med era team samt att vi
            coachar och utbildar cheferna i inkluderande ledarskap.
          </TextMargin>
          <LinkToPage location="/vara-tjanster" text="Våra tjänster" />
        </Article>
      </Section2>
    </>
  );
};

// Styled components

const LinkToSite = styled.a`
  display: flex;
  margin-bottom: 40px;
  font-size: 22px;
  font-weight: bold;
  text-decoration: none;
  list-style: none;
  color: #d3420d;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover > .icon-link {
    transition: all 0.3s ease;
    transform: translateX(7px);
  }

  .icon-link {
    margin-top: 4px;
    font-size: 38px;
    transition: all 0.3s ease;
  }
`;

const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const HeroImage = styled.img`
  height: 100vh;
  width: 100vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  object-fit: cover;
`;

const HeroTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 50px;
  content: "";
  position: absolute;
  background-color: rgba(
    255,
    151,
    103,
    0.7
  ); //RGBA med opacitet för att text ska synas
  @media (max-width: 1025px) {
    padding: 20px;
  }
`;

const HeroHeading = styled.h1`
  font-size: 54px;
  color: #fff;
  font-weight: lighter;
  @media (max-width: 1025px) {
    font-size: 34px;
  }
`;

const HeroText = styled.p`
  font-size: 22px;
  color: #fff;
  font-style: italic;
`;

const Heading = styled.h1`
  font-size: 42px;
  align-self: flex-start;
  padding-top: 20px;
`;

const Text = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  width: 90%;
`;

const TextMargin = styled(Text)`
  @media (min-width: 1025px) {
    margin-top: 130px;
  }
  @media (min-width: 1450px) {
    margin-top: 100px;
  }
`;

const Section = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #eeeeee;

  @media (min-width: 1025px) {
    flex-direction: row;
    justify-content: center;
    padding: 30px;
  }
`;

const Section2 = styled(Section)`
  background: #fde5d6;
`;

const Article = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: left;

  @media (min-width: 1025px) {
    width: 50%;
    padding: 20px;
  }
`;

const ArticleHeading = styled.h2`
  font-size: 34px;
  padding-top: 20px;
  padding-bottom: 10px;
  text-align: left;
`;

const Img = styled.img`
  width: 100%;
  padding-bottom: 16px;
  @media (min-width: 1025px) {
    width: 100%;
  }
`;
